// tslint:disable
/// <reference path="./custom.d.ts" />
/**
 * StoreCore
 * store-front から呼び出される StoreCoreAPI
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as globalImportUrl from 'url';
import { Configuration } from './configuration';
import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from './base';

/**
 * 
 * @export
 * @interface ErrorResponse
 */
export interface ErrorResponse {
    /**
     * エラーコード
     * @type {number}
     * @memberof ErrorResponse
     */
    code?: number;
    /**
     * エラーメッセージ
     * @type {string}
     * @memberof ErrorResponse
     */
    message?: string;
}
/**
 * 
 * @export
 * @interface PostBacklogIssuesRequest
 */
export interface PostBacklogIssuesRequest {
    /**
     * 
     * @type {number}
     * @memberof PostBacklogIssuesRequest
     */
    project_id: number;
    /**
     * 
     * @type {string}
     * @memberof PostBacklogIssuesRequest
     */
    summary: string;
    /**
     * 
     * @type {number}
     * @memberof PostBacklogIssuesRequest
     */
    parent_issue_id?: number;
    /**
     * 
     * @type {string}
     * @memberof PostBacklogIssuesRequest
     */
    description?: string;
    /**
     * 
     * @type {number}
     * @memberof PostBacklogIssuesRequest
     */
    issue_type_id: number;
    /**
     * 
     * @type {number}
     * @memberof PostBacklogIssuesRequest
     */
    priority_id: number;
    /**
     * 
     * @type {number}
     * @memberof PostBacklogIssuesRequest
     */
    assignee_id?: number;
}
/**
 * 
 * @export
 * @interface PostEmailInquiryReplyRequest
 */
export interface PostEmailInquiryReplyRequest {
    /**
     * 
     * @type {string}
     * @memberof PostEmailInquiryReplyRequest
     */
    to_address: string;
    /**
     * 
     * @type {string}
     * @memberof PostEmailInquiryReplyRequest
     */
    company?: string;
    /**
     * 
     * @type {string}
     * @memberof PostEmailInquiryReplyRequest
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof PostEmailInquiryReplyRequest
     */
    phone_number?: string;
    /**
     * 
     * @type {string}
     * @memberof PostEmailInquiryReplyRequest
     */
    inquiry?: string;
    /**
     * 
     * @type {string}
     * @memberof PostEmailInquiryReplyRequest
     */
    inquiry_detail?: string;
}

/**
 * BacklogApi - axios parameter creator
 * @export
 */
export const BacklogApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Backlogに課題を登録する。 
         * @summary SCR0055 Backlog課題登録
         * @param {PostBacklogIssuesRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postBacklogIssues(body: PostBacklogIssuesRequest, options: any = {}): RequestArgs {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling postBacklogIssues.');
            }
            const localVarPath = `/backlog/issues`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};
            const needsSerialization = (<any>"PostBacklogIssuesRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * BacklogApi - functional programming interface
 * @export
 */
export const BacklogApiFp = function(configuration?: Configuration) {
    return {
        /**
         * Backlogに課題を登録する。 
         * @summary SCR0055 Backlog課題登録
         * @param {PostBacklogIssuesRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postBacklogIssues(body: PostBacklogIssuesRequest, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void> {
            const localVarAxiosArgs = BacklogApiAxiosParamCreator(configuration).postBacklogIssues(body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * BacklogApi - factory interface
 * @export
 */
export const BacklogApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * Backlogに課題を登録する。 
         * @summary SCR0055 Backlog課題登録
         * @param {PostBacklogIssuesRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postBacklogIssues(body: PostBacklogIssuesRequest, options?: any) {
            return BacklogApiFp(configuration).postBacklogIssues(body, options)(axios, basePath);
        },
    };
};

/**
 * BacklogApi - object-oriented interface
 * @export
 * @class BacklogApi
 * @extends {BaseAPI}
 */
export class BacklogApi extends BaseAPI {
    /**
     * Backlogに課題を登録する。 
     * @summary SCR0055 Backlog課題登録
     * @param {PostBacklogIssuesRequest} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BacklogApi
     */
    public postBacklogIssues(body: PostBacklogIssuesRequest, options?: any) {
        return BacklogApiFp(this.configuration).postBacklogIssues(body, options)(this.axios, this.basePath);
    }

}


/**
 * EmailApi - axios parameter creator
 * @export
 */
export const EmailApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * お問い合わせに対する返信メールを送信する。 
         * @summary SCR0066 お問い合わせ返信メール送信
         * @param {PostEmailInquiryReplyRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postEmailInquiryReply(body: PostEmailInquiryReplyRequest, options: any = {}): RequestArgs {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling postEmailInquiryReply.');
            }
            const localVarPath = `/email/inquiry-reply`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};
            const needsSerialization = (<any>"PostEmailInquiryReplyRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * EmailApi - functional programming interface
 * @export
 */
export const EmailApiFp = function(configuration?: Configuration) {
    return {
        /**
         * お問い合わせに対する返信メールを送信する。 
         * @summary SCR0066 お問い合わせ返信メール送信
         * @param {PostEmailInquiryReplyRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postEmailInquiryReply(body: PostEmailInquiryReplyRequest, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void> {
            const localVarAxiosArgs = EmailApiAxiosParamCreator(configuration).postEmailInquiryReply(body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * EmailApi - factory interface
 * @export
 */
export const EmailApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * お問い合わせに対する返信メールを送信する。 
         * @summary SCR0066 お問い合わせ返信メール送信
         * @param {PostEmailInquiryReplyRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postEmailInquiryReply(body: PostEmailInquiryReplyRequest, options?: any) {
            return EmailApiFp(configuration).postEmailInquiryReply(body, options)(axios, basePath);
        },
    };
};

/**
 * EmailApi - object-oriented interface
 * @export
 * @class EmailApi
 * @extends {BaseAPI}
 */
export class EmailApi extends BaseAPI {
    /**
     * お問い合わせに対する返信メールを送信する。 
     * @summary SCR0066 お問い合わせ返信メール送信
     * @param {PostEmailInquiryReplyRequest} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmailApi
     */
    public postEmailInquiryReply(body: PostEmailInquiryReplyRequest, options?: any) {
        return EmailApiFp(this.configuration).postEmailInquiryReply(body, options)(this.axios, this.basePath);
    }

}


